import { queryOptions } from '@tanstack/vue-query'
import { computed, unref, type MaybeRef } from 'vue'
import { getUsers } from '../api/get-users'

export interface UsersQueryParams {
  query?: string | null
}

export const getUsersQueryKey = (params: MaybeRef<UsersQueryParams> = {}) =>
  ['users', computed(() => unref(params).query || null) as MaybeRef<string | null>] as const

export const getUsersQueryOptions = (params: MaybeRef<UsersQueryParams> = {}) =>
  queryOptions({
    queryKey: getUsersQueryKey(params),
    queryFn: () => getUsers(unref(params)),
  })
